<template>
  <div :key="'detailInvoiceProductsTable_' + forceUpdate" class="crud-detail-product-fieldset">     
    <div v-if="priceLoading" class="detail-product-price-overlay" aria-live="polite">
      <b-spinner small label="Consultando precio"></b-spinner>
      <span>Consultando precio…</span>
    </div>
    <b-row :class="[{'block-product-add':crud.form.detail_register.editing}]">
      <b-col :lg="7 + widthShowDiscount" :md="7 + widthShowDiscount">
        <b-row>
          <b-col lg="6" md="6" id="container_detail_product_select">
            <FindObject :key="crud.form.detail_register.forceRenderSelectProduct"
                        render="search"
                        type="products" 
                        @select-object="loadProducts($event)" 
                        :valueID="crud.form.detail_register.product_id"
                        :where="conditionProductsActive"
                        :disabled="onlyDiscount"
                        id="detail_product_select" 
                        title="Buscar por código de barra (F3) | Buscador (F4)" 
                        ref="searchProducts"/> 
            <div
              class="detail-product-stock-control"
              v-if="crud.form.detail_register.selectedProduct"
              v-b-tooltip.hover.top
              :title="productControlsStock ? 'Este producto controla stock' : 'Este producto no controla stock'">
              <b-badge :variant="productControlsStock ? 'success' : 'secondary'">
                <AppIcon :name="productControlsStock ? 'inventory_2' : 'block'" />
                <span>{{ productControlsStock ? 'Controla stock' : 'Sin control stock' }}</span>
              </b-badge>
            </div>

            <b-popover target="detail_product_select"
                       triggers="hover focus click"
                       placement="auto"
                       container="container_detail_product_select"
                       v-if="crud.form.detail_register.selectedProduct">
              <template #title><AppIcon name="box" class="mr-1" />Stock</template>
              <div class="detail-product-popover-list">
                <div class="detail-product-popover-list__row">
                  <span class="detail-product-popover-list__label">Depósito</span>
                  <span class="detail-product-popover-list__value">{{parseFloat(this.crud.form.detail_register.selectedProduct.stock).toFixed(2)}} {{this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default.reference}}</span>
                </div>
                <div class="detail-product-popover-list__row">
                  <span class="detail-product-popover-list__label">Pendiente</span>
                  <span class="detail-product-popover-list__value">{{parseFloat(this.crud.form.detail_register.selectedProduct.stock_pending).toFixed(2)}} {{this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default.reference}}</span>
                </div>
                <div class="detail-product-popover-list__row">
                  <span class="detail-product-popover-list__label">Control</span>
                  <span class="detail-product-popover-list__value" :class="productControlsStock ? 'text-success' : 'text-muted'">
                    {{ productControlsStock ? 'Controla stock' : 'No controla stock' }}
                  </span>
                </div>
              </div>
            </b-popover>
          </b-col>            
          
          <b-col lg="6" md="6">                          
            <div v-if="!haveOnlyProduct">
              <div v-if="haveColorsWaist">
                <!-- COLOR Y TALLE --> 
                <b-row>
                  <b-col lg="6" md="6" v-if="crud.form.detail_register.opt_color.length>0">
                    <b-form-group label="Color" :disabled="onlyDiscount">
                      <v-select :options="crud.form.detail_register.opt_color" 
                                v-model="crud.form.detail_register.color" 
                                placeholder="Color" 
                                :multiple="false" 
                                :select-on-tab="true"
                                @input="selectColorCombinado"></v-select>
                    </b-form-group>
                  </b-col>                            
                  <b-col lg="6" md="6" v-if="crud.form.detail_register.opt_waist.length>0">
                    <b-form-group label="Talle" :disabled="onlyDiscount">                                
                      <v-select :options="crud.form.detail_register.opt_waist" 
                                v-model="crud.form.detail_register.waist" 
                                placeholder="Talle" 
                                :multiple="false" 
                                :select-on-tab="true"
                                @input="selectWaistCombinado"></v-select>                      
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <!-- COLOR -->
                <div v-if="haveOnlyColors">
                  <b-row>
                    <b-col lg="6" md="6">
                      <b-form-group label="Color" :disabled="onlyDiscount">
                        <v-select :options="crud.form.detail_register.opt_color" 
                                  v-model="crud.form.detail_register.color" 
                                  placeholder="Color" 
                                  :multiple="false" 
                                  :select-on-tab="true"
                                  @input="selectColorSimple"></v-select>
                      </b-form-group>                              
                    </b-col>
                  </b-row>
                </div>

                <!-- TALLE -->
                <div v-if="haveOnlyWaist">
                  <b-row>
                    <b-col lg="6" md="6">                                
                      <b-form-group label="Talle" :disabled="onlyDiscount">                                
                        <v-select :options="crud.form.detail_register.opt_waist" 
                                  v-model="crud.form.detail_register.waist" 
                                  placeholder="Talle" 
                                  :multiple="false" 
                                  :select-on-tab="true"
                                  @input="selectWaistSimple"></v-select>                      
                      </b-form-group>                              
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>                          
          </b-col>
        </b-row>
      </b-col>
      <b-col :lg="5 - widthShowDiscount" :md="5 - widthShowDiscount" class="detail-product-pricing-fields">
        <b-row>
          
          <b-col :lg="3 + widthShowDiscount" :md="3 + widthShowDiscount">
            <b-form-group label="Cantidad" :disabled="onlyDiscount" v-if="crud.form.detail_register.selectedProduct">
              <app-text-input v-model="crud.form.detail_register.quantity"
                              type="number"
                              min="0"
                              step="1"
                              class="form-control"
                              size="sm"
                              ref="inputQuantity"/>
            </b-form-group>
          </b-col>                   

          <b-col :lg="4 + widthShowDiscount" :md="4 + widthShowDiscount" class="pl-md-0 pr-md-0">
            <div v-if="crud.form.detail_register.selectedProduct" id="detail_product_amount">
              <div  v-if="crud.form.detail_register.unit_measurement">                  
                <b-form-group v-if="crud.form.detail_register.currency" :disabled="onlyDiscount"> 
                  <template #label>Importe <b-icon icon="info-circle-fill" id="detail_product_amount" title="Más Información"></b-icon></template>
                  <b-input-group :prepend="crud.form.detail_register.currency.symbol" size="sm" class="crud-detail-product-prepend-amount">
                    <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                          size="sm"
                          :disabled="!editPrice"
                          :readonly="!editPrice"
                          class="form-control"
                          @input="crud.form.detail_register.amount_raw_internal = undefined"/>

                    <template #append>
                      <b-dropdown :text="crud.form.detail_register.unit_measurement.reference" 
                                  :title="crud.form.detail_register.unit_measurement.name" 
                                  variant="secondary"
                                  class="curd-detail-product-select-unit-measurement"
                                  v-if="Object.keys(arr.equivalences).length">
                        <b-dropdown-item v-for="element in arr.equivalences" 
                                        :key="element.id" 
                                        @click="setUnitMeasurementAlternativeRecalculePrice(element)">
                          {{element.name}} ({{element.reference}})
                        </b-dropdown-item>
                      </b-dropdown>
                      <b-button v-else size="sm" variant="secondary" class="curd-detail-product-select-unit-measurement" :text="crud.form.detail_register.unit_measurement.reference">
                        {{crud.form.detail_register.unit_measurement.reference}} 
                      </b-button>
                    </template>                            
                  </b-input-group>
                </b-form-group>
                <b-form-group v-else size="sm" :disabled="onlyDiscount"> 
                  <template #label>Importe <b-icon icon="info-circle-fill" id="detail_product_amount" title="Más Información"></b-icon></template>
                  <b-input-group prepend="$" size="sm" class="crud-detail-product-prepend-amount">
                    <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                          size="sm"
                          :disabled="!editPrice"
                          :readonly="!editPrice"
                          class="form-control"
                          @input="crud.form.detail_register.amount_raw_internal = undefined"/>

                          <template #append>
                            <b-dropdown :text="crud.form.detail_register.unit_measurement.reference" 
                                        :title="crud.form.detail_register.unit_measurement.name" 
                                        variant="secondary"
                                        class="curd-detail-product-select-unit-measurement"
                                        v-if="Object.keys(arr.equivalences).length">
                              <b-dropdown-item v-for="element in arr.equivalences" 
                                              :key="element.id" 
                                              @click="setUnitMeasurementAlternativeRecalculePrice(element)">
                                {{element.name}} ({{element.reference}})
                              </b-dropdown-item>
                            </b-dropdown>
                            <b-button v-else size="sm" variant="secondary" class="curd-detail-product-select-unit-measurement" :text="crud.form.detail_register.unit_measurement.reference">
                              {{crud.form.detail_register.unit_measurement.reference}} 
                            </b-button>
                          </template>                                               
                  </b-input-group>
                </b-form-group>  
              </div>
              <div v-else>
                <b-form-group v-if="crud.form.detail_register.currency" :disabled="onlyDiscount"> 
                  <template #label>Importe <b-icon icon="info-circle-fill" id="detail_product_amount" title="Más Información"></b-icon></template>
                  <b-input-group :prepend="crud.form.detail_register.currency.symbol" size="sm" class="crud-detail-product-prepend-amount">
                    <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                          size="sm"
                          :disabled="!editPrice"
                          :readonly="!editPrice"
                          class="form-control"
                          @input="crud.form.detail_register.amount_raw_internal = undefined"/>
                  </b-input-group>
                </b-form-group>
                <b-form-group  v-else size="sm" :disabled="onlyDiscount"> 
                  <template #label>Importe <b-icon icon="info-circle-fill" id="detail_product_amount" title="Más Información"></b-icon></template>
                  <b-input-group prepend="$" size="sm" class="crud-detail-product-prepend-amount">
                    <app-number-input :key="crud.form.detail_register.forceRenderPrice" v-model="crud.form.detail_register.amount"
                          size="sm"
                          :disabled="!editPrice"
                          :readonly="!editPrice"
                          class="form-control"
                          @input="crud.form.detail_register.amount_raw_internal = undefined"/>
                  </b-input-group>
                </b-form-group>
              </div>

              <b-popover target="detail_product_amount"
                        triggers="hover focus click"
                        placement="topleft"
                        container="container_detail_product_select"
                        v-if="crud.form.detail_register.amount">
                <template #title><AppIcon name="money" class="mr-1" />Precio Unitario</template>
                <div class="detail-product-popover-list">
                  <div class="detail-product-popover-list__row">
                    <span class="detail-product-popover-list__label">Sin IVA</span>
                    <span class="detail-product-popover-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.crud.form.detail_register.selectedProduct.list.currency.code}).format(this.crud.form.detail_register.amount)}}</span>
                  </div>
                  <div class="detail-product-popover-list__row" v-if="!notIva">
                    <span class="detail-product-popover-list__label">C/IVA</span>
                    <span class="detail-product-popover-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.crud.form.detail_register.selectedProduct.list.currency.code}).format(calcPriceIva(currentDetailRawAmount(), this.crud.form.detail_register.selectedProduct.amount.aliquot_iva))}}</span>
                  </div>
                  <div class="detail-product-popover-list__row" v-if="!notIva && methodPayment && parseFloat(methodPayment.surcharge) > 0">
                    <span class="detail-product-popover-list__label">C/IVA · {{this.methodPayment.name}} ({{this.methodPayment.surcharge}}%)</span>
                    <span class="detail-product-popover-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.crud.form.detail_register.selectedProduct.list.currency.code}).format(calcSurchargePriceIva(currentDetailRawAmount(), this.crud.form.detail_register.selectedProduct.amount.aliquot_iva, this.methodPayment.surcharge))}}</span>
                  </div>
                </div>
              </b-popover>
            </div>        
          </b-col>

          <b-col lg="3" md="3" v-if="showDiscount && crud.form.detail_register.selectedProduct">
            <b-form-group label="Descuento">                         
              <b-input-group append="%" size="sm" class="crud-detail-product-append-discount">
                <app-text-input v-model="crud.form.detail_register.discount"
                                type="number"
                                min="0"
                                max="100"
                                step="1"
                                class="form-control"
                                size="sm"/>
              </b-input-group>
            </b-form-group>              
          </b-col>        

          <b-col lg="1" md="1" class="crud-new-orders-button-add" v-if="crud.form.detail_register.selectedProduct">
            <b-button @click="handleAddButtonClick"
                      v-b-tooltip.hover
                      :variant="crud.form.detail_register.button.variant"
                      :title="crud.form.detail_register.button.title"
                      :disabled="priceLoading"
                      size="sm">
              <i :class="crud.form.detail_register.button.icon"></i>
            </b-button>                                                    
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="12" v-if="crud.form.detail_register.editing" class="block-product-add-div">
        <b-icon icon="circle-fill" animation="throb" font-scale="2"></b-icon>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="12">                  
        <b-table class="mb-0 app-table app-table--compact crud-order-table-detail"
          responsive="sm"
          :stacked="isMobileViewport ? 'md' : false"
          :hover="true"
          :small="true"
          :fixed="true"
          :items="crud.form.detail"
          :fields="tableDetailNewOrder">

          <template v-slot:table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.width }"
            >
          </template>

          <template v-slot:cell(code)="data">
            {{data.item.product.code}}
          </template>

          <template v-slot:cell(product)="data">
            <div :class="isMobileViewport ? 'text-wrap' : 'text-truncate'" v-b-tooltip.hover :title="getProductCellText(data.item)">
              <span>
                {{data.item.product.name}}
                <span v-if="data.item.product.color">
                  - <i>{{data.item.product.color.name}}</i>
                </span>

                <span v-if="data.item.product.waist && data.item.product.waist.name">
                  - <i>{{data.item.product.waist.name}}</i>
                </span>
              </span>
              <span
                class="detail-product-table-stock-control"
                :class="productItemControlsStock(data.item) ? 'detail-product-table-stock-control--active' : 'detail-product-table-stock-control--inactive'"
                v-b-tooltip.hover
                :title="productItemControlsStock(data.item) ? 'Controla stock' : 'Sin control stock'">
                <AppIcon :name="productItemControlsStock(data.item) ? 'inventory_2' : 'block'" />
              </span>
            </div>
          </template>

          <template v-slot:cell(list)="data">              
            <span v-if="data.item.price_list">                                                        
              {{data.item.price_list.reference}}
            </span>              
          </template>   

          <template v-slot:cell(quantity)="data">                            
            {{ parseFloat(data.item.quantity).toFixed(2) }} 
            <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
          </template>   

          <template v-slot:cell(amount)="data">  
            {{formatDetailNetPrice(data.item, data.item.amount)}}
          </template>   

          <template v-slot:cell(amount_iva)="data">
            {{formatDetailPrice(data.item, data.item.amount)}}
          </template>   

          <template v-slot:cell(discount)="data">  
            <span :id="'detail-product-discount-info-' + data.index"
                  class="detail-discount-rate"
                  :class="{ 'detail-discount-rate--info': !notIva && hasDetailItemIva(data.item) }"
                  :tabindex="!notIva && hasDetailItemIva(data.item) ? 0 : null">{{data.item.discount}}%</span>
            {{formatDetailDiscount(data.item)}}
            <b-popover v-if="!notIva && hasDetailItemIva(data.item)"
                       :target="'detail-product-discount-info-' + data.index"
                       triggers="click blur"
                       placement="bottom"
                       custom-class="detail-discount-popover">
              <div class="detail-discount-popover__row"><span>Lista</span><strong>{{data.item.price_list ? data.item.price_list.reference : '-'}}</strong></div>
              <div class="detail-discount-popover__section">
                <div class="detail-discount-popover__row"><span>Importe unitario</span><strong>{{formatDetailNetPrice(data.item, data.item.amount)}}</strong></div>
                <div class="detail-discount-popover__row"><span>IVA <small class="detail-discount-popover__iva">{{parseFloat(getDetailItemAliquotIva(data.item) || 0).toFixed(2)}}%</small></span><strong>{{formatDetailNetPrice(data.item, getDetailIvaAmount(data.item))}}</strong></div>
                <div class="detail-discount-popover__row"><span>Precio unit. c/IVA</span><strong>{{formatDetailPrice(data.item, data.item.amount)}}</strong></div>
                <div class="detail-discount-popover__row" v-if="parameters.salePriceCalc"><span>Descuento del renglón <small class="detail-discount-popover__iva">{{parseFloat(data.item.discount || 0).toFixed(2)}}%</small></span><strong>{{formatDetailDiscount(data.item)}}</strong></div>
                <div class="detail-discount-popover__row" v-else><span>Descuento <small class="detail-discount-popover__iva">{{parseFloat(data.item.discount || 0).toFixed(2)}}%</small></span><strong>{{formatDetailPrice(data.item, getDetailUnitDiscount(data.item))}}</strong></div>
                <div class="detail-discount-popover__row" v-if="!parameters.salePriceCalc && parseFloat(data.item.discount) > 0"><span>Precio unit. final</span><strong>{{formatDetailPrice(data.item, getDetailUnitFinal(data.item))}}</strong></div>
                <div class="detail-discount-popover__row"><span>Cantidad</span><strong>{{getDetailQuantityLabel(data.item)}}</strong></div>
                <div class="detail-discount-popover__row"><span>Total final</span><strong>{{formatDetailTotal(data.item)}}</strong></div>
              </div>
            </b-popover>
          </template>   
          
          <template v-slot:cell(total)="data">  
            {{formatDetailTotal(data.item)}}
          </template>   

          <template v-slot:cell(f_action)="data">
            <b-dropdown right no-caret
                        size="sm"
                        variant="link"
                        boundary="window"
                        toggle-class="app-table-action-toggle"
                        :ref="'actionItem_' + data.index"
                        :disabled="crud.form.detail_register.button.editing">
              <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
              <b-dropdown-header>Acciones</b-dropdown-header>
              <b-dropdown-item @click="editItem(data.item, data.index)">
                <AppIcon name="edit" /> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="deleteItem(data.index)" v-if="!onlyDiscount">
                <AppIcon name="delete" class="text-danger" /> Eliminar
              </b-dropdown-item>     
            </b-dropdown>                                
          </template>                    
        </b-table>                  
      </b-col>
    </b-row>

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <!-- CRUD FACILITY LOAD DATA COLOR / WAIST -->
    <b-modal v-model="modal.facility.active"
            :size="widthModalFacility"
            body-class="app-modal-form">
      <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="palette" /></span><h5 class="app-modal-header__title">{{ modal.facility.title }}</h5></div>

      <b-row>
        <b-col lg="12">          
          <div v-if="crud.facility.type=='colors'">             
            <div v-if="(crud.facility.products.length > 0) && (crud.facility.products.length <= crud.facility.totalItems)">
              <div v-for="(value, index) in orderFacility" :key="index">              
                <b-row>
                  <b-col lg="5" md="5">                  
                    <b-form-group label="Color">
                      {{value.item.name}}
                    </b-form-group>
                  </b-col>
                  <b-col :lg="2 + widthShowDiscount" :md="2 + widthShowDiscount">
                    <b-form-group label="Cantidad">
                      <b-form-input v-model="value.quantity" 
                            type="number" 
                            min="0" 
                            step="1"
                            size="sm" 
                            class="form-control"/>                      
                    </b-form-group>
                  </b-col>                    
                  <b-col :lg="3 + widthShowDiscount" :md="3 + widthShowDiscount">
                    <b-form-group label="Importe" v-if="value.currency"> 
                      <b-input-group :prepend="value.currency.symbol" size="sm">
                        <app-number-input v-model="value.amount"
                              min="0"
                              size="sm"
                              class="form-control"
                              :disabled="!editPrice"
                              :readonly="!editPrice" />
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label="Importe" v-else> 
                      <b-input-group prepend="$">
                        <app-number-input v-model="value.amount"
                              min="0"
                              size="sm"
                              class="form-control"
                              :disabled="!editPrice"
                              :readonly="!editPrice" />
                      </b-input-group>
                    </b-form-group>                          
                  </b-col> 
                  <b-col lg="2" md="2" v-if="showDiscount">
                    <b-form-group label="Descuento">                         
                      <b-input-group append="%" size="sm">
                        <app-text-input v-model="value.discount"
                                        type="number"
                                        min="0"
                                        max="100"
                                        step="1"
                                        class="form-control"
                                        size="sm"/>
                      </b-input-group>
                    </b-form-group>              
                  </b-col>                                   
                </b-row>
              </div>
            </div>
            <EmptyState v-else icon="check" title="Todos los colores ya fueron cargados" />
          </div>

          <div v-if="crud.facility.type=='waist'">
            <div v-if="(crud.facility.products.length > 0) && (crud.facility.products.length <= crud.facility.totalItems)">
              <div v-for="(value, index) in orderFacility" :key="index">              
                <b-row>
                  <b-col lg="5" md="5">                  
                    <b-form-group label="Talle">
                      {{value.item.name}}
                    </b-form-group>
                  </b-col>
                  <b-col :lg="2 + widthShowDiscount" :md="2 + widthShowDiscount">
                    <b-form-group label="Cantidad">
                      <b-form-input v-model="value.quantity" 
                            type="number" 
                            min="0" 
                            step="1"
                            size="sm" 
                            class="form-control"/>                      
                    </b-form-group>
                  </b-col>                    
                  <b-col :lg="3 + widthShowDiscount" :md="3 + widthShowDiscount">
                    <b-form-group label="Importe" v-if="value.currency"> 
                      <b-input-group :prepend="value.currency.symbol" size="sm">
                        <app-number-input v-model="value.amount"
                              min="0"
                              size="sm"
                              class="form-control"
                              :disabled="!editPrice"
                              :readonly="!editPrice" />
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label="Importe" v-else> 
                      <b-input-group prepend="$">
                        <app-number-input v-model="value.amount"
                              min="0"
                              size="sm"
                              class="form-control"
                              :disabled="!editPrice"
                              :readonly="!editPrice" />
                      </b-input-group>
                    </b-form-group>                          
                  </b-col>    
                  <b-col lg="2" md="2" v-if="showDiscount">
                    <b-form-group label="Descuento">                         
                      <b-input-group append="%" size="sm">
                        <app-text-input v-model="value.discount"
                                        type="number"
                                        min="0"
                                        max="100"
                                        step="1"
                                        class="form-control"
                                        size="sm"/>
                      </b-input-group>
                    </b-form-group>              
                  </b-col>                                
                </b-row>
              </div>
            </div>
            <EmptyState v-else icon="check" title="Todos los talles ya fueron cargados" />
          </div>        
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancelFacility()">Cancelar</b-button>
        <b-button variant="dark" @click="saveFacility()"><AppIcon name="check" class="mr-1" />Aceptar</b-button>
      </div>
    </b-modal>      

    <!-- CRUD MULTIPLE LIST PRICE -->
    <b-modal v-model="modal.multipleListPrice.active"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @shown="focusFirstMultipleListPriceAction"
            @hidden="onMultipleListPriceHidden">
      <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="payments" /></span><h5 class="app-modal-header__title">{{ modal.multipleListPrice.title }}</h5></div>

      <div class="app-modal-detail-list mb-3">
        <div class="app-modal-detail-list__row"><span class="app-modal-detail-list__label">Producto</span><span class="app-modal-detail-list__value"><b>{{ modal.multipleListPrice.product }}</b></span></div>
        <div class="app-modal-detail-list__row"><span class="app-modal-detail-list__label">Código</span><span class="app-modal-detail-list__value">{{ modal.multipleListPrice.code }}</span></div>
      </div>
      <div class="multiple-list-price-toolbar">
        <b-form-checkbox v-model="showMultipleListPriceWithIva"
                         switch
                         size="sm"
                         @change="saveMultipleListPriceIvaPreference">
          Mostrar precio con IVA
        </b-form-checkbox>
      </div>
      <b-row>
        <b-col lg="12">          
          <b-table 
            class="app-table app-table--compact mb-0"
            responsive="sm"
            :stacked="isMobileViewport ? 'md' : false"
            :hover="true"
            :fixed="false"
            :items="tableMultipleListPrice.items"
            :fields="tableMultipleListPrice.fields"
            :tbody-tr-class="multipleListPriceRowClass">
            
            <template v-slot:cell(list)="data">  
              <div v-if="data.item.list">
                {{data.item.list.reference}}
              </div>
            </template>  

            <template v-slot:cell(price_list)="data">                
              <div v-if="data.item.amount && (data.item.amount.unit_measurement_initial.reference != data.item.amount.unit_measurement_result.reference)">
                <div v-if="data.item && data.item.list && data.item.list.currency">
                  <span v-if="data.item.amount">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount.amount_initial, data.item.amount.desc, data.item))}}
                  </span>
                  <span v-if="data.item.amount.unit_measurement_initial">{{data.item.amount.unit_measurement_initial.reference}}</span>             
                </div>
              </div>
            </template>

            <template v-slot:cell(price_public)="data">   
              <div v-if="data.item && data.item.list && data.item.list.currency">
                <span v-if="data.item.amount">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(sumDiscountPrice(data.item.amount.amount_total, data.item.amount.desc, data.item))}}
                </span>
                <span v-if="data.item.amount && data.item.amount.unit_measurement_result">
                  {{data.item.amount.unit_measurement_result.reference}}
                </span>
              </div>
            </template>

            <template v-slot:cell(desc)="data">       
              <div v-if="data.item.amount && parseFloat(data.item.amount.desc) > 0">
                {{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits:2}).format(parseFloat(data.item.amount.desc)/100)}}
              </div>
            </template>

            <template v-slot:cell(price_desc)="data">                
              <div v-if="data.item.amount">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount.amount_total)}}                
                <span v-if="data.item.amount.unit_measurement_result">{{data.item.amount.unit_measurement_result.reference}}</span>
              </div>
            </template>

            <template v-slot:cell(price_iva)="data">
              <div v-if="data.item.amount && data.item.list && data.item.list.currency">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(getMultipleListPriceWithIva(data.item))}}
                <span v-if="data.item.amount.unit_measurement_result">{{data.item.amount.unit_measurement_result.reference}}</span>
              </div>
            </template>

            <template v-slot:cell(action)="data">  
              <b-button 
                variant="primary"
                size="sm" 
                :class="['find-btn-select', 'multiple-list-price-select-btn', { 'find-btn-select--mobile': isMobileViewport }]"
                title="Seleccionar lista de precios"
                @click="selectMultipleListPrice(data.item)"
                @focus="multipleListPriceActiveIndex = data.index"
                :disabled="multipleListPriceSelecting"
                :ref="'actionPriceItem_' + data.index">                
                <AppIcon name="arrow_circle_right" label="Seleccionar lista de precios" /> <span v-if="isMobileViewport">Seleccionar</span>
              </b-button>
            </template>                          
          </b-table>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" size="sm" @click="cancelMultipleListPrice()">Cancelar</b-button>
      </div>
    </b-modal>   

    <!-- CRUD BARCODE -->
    <b-modal v-model="modal.barcode.active"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            body-class="app-modal-form">
      <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="upc-scan" /></span><h5 class="app-modal-header__title">{{ modal.barcode.title }}</h5></div>

      <b-row>
        <b-col md="12" class="mb-2">
          <div class="text-center">
            <AppIcon name="upc-scan" :font-scale="3" class="mb-2 text-muted" />

            <b-form-group label="Código de barras" class="text-left">
              <b-form-input v-model="modal.barcode.value"
                    ref="barcodeInput"
                    type="text"
                    size="sm"
                    :disabled="!barcodeConfirm || modal.barcode.searching"
                    placeholder="Ingresar o escanear un código"
                    @keyup.enter="manualSearchBarcode()" />
            </b-form-group>

            <template v-if="barcodeConfirm">
              <b-row class="text-left">
                <b-col md="4">
                  <b-form-group label="Cantidad">
                    <b-form-input ref="barcodeQuantityInput"
                                  v-model.number="modal.barcode.quantity"
                                  type="number"
                                  min="0"
                                  step="1"
                                  size="sm"
                                  @keyup.enter="$refs.barcodeInput && $refs.barcodeInput.focus()" />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-alert v-if="modal.barcode.lastAdded" show variant="success" class="py-2 mt-3 mb-0 text-left">
                <AppIcon name="check" class="mr-1" />
                <strong>x{{ modal.barcode.lastAdded.quantity }}</strong> — {{ modal.barcode.lastAdded.name }}
              </b-alert>

              <b-alert v-if="modal.barcode.notFound" show variant="warning" class="py-2 mt-3 mb-0 text-left">
                <AppIcon name="warning" class="mr-1" />
                No encontrado: <strong>{{ modal.barcode.notFound }}</strong>
              </b-alert>
            </template>
          </div>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" size="sm" @click="cancelScanBarcode()">
          {{ barcodeConfirm ? 'Cerrar' : 'Cancelar' }}
        </b-button>
      </div>
    </b-modal>
  </div>       
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Funciones from '@/handler/funciones' 
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'    
  import Param from '@/config/parameters'
  import moment from 'moment'

  export default {
    props: {
      customer_id:{
        type: Number,
        required: true,
      },
      price_list_id:{
        type: Number,
        default: 0,
      },     
      reason_id: {
        type: Number,
        default: 0,
      },
      disableCustomerPriceListFallback: {
        type: Boolean,
        default: false,
      },
      editPrice: {
        type: Boolean,
        default: false,
      },
      validStock: {
        type: Boolean,
        default: false,
      },
      detailEdit: {
        type: [Array, Object],
        default: null,
      },
      showDiscount: {
        type: Boolean,
        default: true,        
      },
      onlyDiscount: {
        type: Boolean,
        default: false,
      },
      forceUpdate: {
        type: Number,
        default: 0,
      },
      validItemDuplicated: {
        type: Boolean,
        default: true,
      },
      barcodeAddAutomatic: {
        type: Boolean,
        default: false,
      },
      barcodeConfirm: {
        type: Boolean,
        default: false,
      },
      getItemOnlyPublished: {
        type: Boolean,
        default: false,
      },            
      methodPayment:{
        type: [Object, Array],
        default: () => [],
      },            
      ivaConditions: {
        type: Array,
        default: () => [],
      },
      notIva: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      FindObject,
    },
    data: () => {
      return {  
        tableDetailNewOrder : [],           
        tableMultipleListPrice : {
          items: [],
          fields: [],
        },
        multipleListPriceActiveIndex: -1,
        multipleListPriceSelecting: false,
        productSelectionPendingId: null,
        showMultipleListPriceWithIva: true,
        crud: {
          form: {
            detail_register: {
              opt_color: [],
              opt_waist: [],
              color: null,
              waist: null,
              quantity: 0,
              quantityOld: 0,
              amount: 0,
              discount: 0,
              currency: null,              
              product_id: 0,
              product: null,              
              selectedProduct: null,
              forceRenderSelectProduct: 0,
              forceRenderPrice: 0,
              unit_measurement: null,
              unit_measurement_id: 0,
              amount_initial: 0,
              price_list_id: 0,
              price_list: null,
              button: {
                icon: 'fa fa-plus',
                title: "Agregar Item (CTRL + SHIFT + '+')",
                variant: 'success',
                editing: false
              },
              editing: false,
            },            
            detail: [],   
            editOrder: false,    
          },
          facility: {            
            type: '',
            products: null,  
            totalItems: 0,       
          }           
        },
        editing: {
          status: false,
          price: 0,
          unit_measurement: null,
          list: null,
        },
        modal: {
          facility: {
            active: false,
            title: '', 
          },
          multipleListPrice: {
            active: false,
            title: '', 
            code: '',
            product: '',
          },
          barcode: {
            active: false,
            title: 'Escaneo código de barras',
            value: '',
            timeout: null,
            scanDelay: 100,
            quantity: 1,
            searching: false,
            lastAdded: null,
            notFound: '',
            pendingAdd: false,
          },
        },
        arr: {
          equivalences: [],
        },
        parameters: {
          salePriceCalc: Helper.hasParametersAccess(Param.P75),
        },
        configurations: null,
        priceLoading: false,
        priceRequestSequence: 0,
        isMobileViewport: false,
      }
    },
    watch: {
      isMobileViewport() {
        this.configFieldsTable()
      },
      notIva() {
        this.configFieldsTable()
      },
      price_list_id: function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.resetPriceContext()
        }
      },
      disableCustomerPriceListFallback: function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.resetPriceContext()
        }
      },
      'crud.form.detail_register.selectedProduct': function (newQuestion, oldQuestion) {        
        if(newQuestion) {          
          // le quitamos la validacion if(this.editPrice)  que viene seteado como un parametro del componente
          if(this.editing.status) {
            const rawEditingPrice = this.normalizeNumericValue(this.editing.price, 0)
            this.crud.form.detail_register.amount = this.normalizeAmountForDisplay(this.editing.price)
            if(this.parameters.salePriceCalc) {
              this.crud.form.detail_register.amount_raw_internal = rawEditingPrice
            }
            this.crud.form.detail_register.currency = this.editing.list.currency

            if(this.editing.unit_measurement) {
              this.crud.form.detail_register.unit_measurement = this.editing.unit_measurement
              this.crud.form.detail_register.unit_measurement_id = this.editing.unit_measurement.id
            }
          } else {
            this.crud.form.detail_register.quantity = this.quantityProducts
            const rawPriceSimple = this.normalizeNumericValue(newQuestion.price_simple, 0)
            this.crud.form.detail_register.amount = this.normalizeAmountForDisplay(newQuestion.price_simple)
            if(this.parameters.salePriceCalc) {
              this.crud.form.detail_register.amount_raw_internal = rawPriceSimple
            }
            this.crud.form.detail_register.currency = newQuestion.list.currency

            if(newQuestion.unit_measurement_sale) {
              this.crud.form.detail_register.unit_measurement = newQuestion.unit_measurement_sale
              this.crud.form.detail_register.unit_measurement_id = newQuestion.unit_measurement_sale.id
            }
          }                            

          this.editing.status = false
          this.editing.price = 0
          this.editing.list = null
          this.editing.unit_measurement = null
        
          const hasAmountData = !!newQuestion.amount
          const priceInitial = this.normalizeNumericValue(newQuestion.price_initial, 0)
          const priceSimple = this.normalizeNumericValue(newQuestion.price_simple, 0)
          const amountBase = hasAmountData
            ? this.normalizeNumericValue(newQuestion.amount.amount, priceInitial || priceSimple)
            : (priceInitial || priceSimple)
          const amountInitial = hasAmountData
            ? this.normalizeNumericValue(newQuestion.amount.amount_initial, amountBase)
            : amountBase
          const amountDesc = hasAmountData
            ? this.normalizeNumericValue(newQuestion.amount.desc, 0)
            : 0

          if(priceInitial === priceSimple) {
            this.crud.form.detail_register.amount_initial = amountBase
          } else if(amountDesc > 0) {
            this.crud.form.detail_register.amount_initial = amountInitial - ((amountInitial * amountDesc) / 100)
          } else {
            this.crud.form.detail_register.amount_initial = amountInitial
          }
          this.crud.form.detail_register.price_list_id = newQuestion.list.id
          this.crud.form.detail_register.price_list = newQuestion.list
          this.loadEquivalences()

          if (this.modal.barcode.pendingAdd) {
            this.modal.barcode.pendingAdd = false
            this.$nextTick(() => this._addFromBarcode())
          }
        }
      },
    },  
    computed: {
      // CONDITIONS SELECT
      conditionProductsActive() {
        if(this.getItemOnlyPublished) {
          return [
            {field: 'm_products.active', condition: true},
            {field: 'm_products.published', condition: true}
          ];                    
        } else {
          return [{field: 'm_products.active', condition: true}];    
        }        
      },

      // MODULES ACTIVES
      moduleDepositActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.DEPOSITOS) {
            status = true
          }
        })
        return status
      },

      productControlsStock() {
        return !this.crud.form.detail_register.selectedProduct ||
               this.crud.form.detail_register.selectedProduct.control_stock !== false
      },

      // CONFIGURACION DE PRODUCTO - VARIEDAD
      haveColorsWaist() {
        if(this.crud.form.detail_register.product) {
          if(this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyColors() {     
        if(this.crud.form.detail_register.product) { 
          if( this.crud.form.detail_register.product.colors.length && 
              !this.crud.form.detail_register.product.waist.length && 
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyWaist() {
        if(this.crud.form.detail_register.product) { 
          if( this.crud.form.detail_register.product.waist.length && 
              !this.crud.form.detail_register.product.colors.length &&
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyProduct() {
        if(this.crud.form.detail_register.product) { 
          if( !this.crud.form.detail_register.product.colors.length && 
              !this.crud.form.detail_register.product.waist.length &&
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },  

      // GET COLOR
      getColorWaistUnique() {        
        var arrColorsWaist = []         
        var arrColorsWaistTMP = []                  
        if(this.crud.form.detail_register.product) {          
          this.crud.form.detail_register.product.colors_waist.forEach(element => {
            if(!arrColorsWaistTMP.includes(element.color.id)) {
              arrColorsWaist.push(element)
              arrColorsWaistTMP.push(element.color.id)
            }          
          });       
          return arrColorsWaist
        }       
      },
      getWaistByColor() {                
        var waist = []        
        if(this.crud.form.detail_register.color) {
          if(this.crud.form.detail_register.color.code) {            
            this.crud.form.detail_register.product.colors_waist.forEach(element => {                        
              if(element.color.id == this.crud.form.detail_register.color.code.id) {              
                waist.push(element)
              }
            });
          }
        }
        return waist
      },               

      // CONFIGURATION SHOW DISCOUNT
      widthModalFacility () {
        if(this.showDiscount) {
          return 'lg'
        } else {
          return 'md'
        }
      },
      widthShowDiscount () {
        if(this.showDiscount) {
          return 0
        } else {
          return 1
        }
      },    

      // FACILITY
      orderFacility() {  
        if(this.crud.facility.type=='colors') {
          if((this.crud.facility.products.length > 0) && (this.crud.facility.products.length <= this.crud.facility.totalItems)) {                              
            return Funciones.sortArrayString(this.crud.facility.products,'itemName',1)                             
          } else {
            return []
          }
        }

        if(this.crud.facility.type=='waist')       {
          if((this.crud.facility.products.length > 0) && (this.crud.facility.products.length <= this.crud.facility.totalItems)) {
            return Funciones.sortArrayInteger(this.crud.facility.products,'itemOrder',1)                             
          } else {
            return []
          }
        }        
      }, 
      
      // VALUES DEFAULT
      quantityProducts() {
        if(this.configurations) {
          return parseInt(this.configurations[0].value_number);
        } else {
          return 0;
        }
      },

    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadConfigurations()
      this.loadMultipleListPriceIvaPreference()
      this.configFieldsTable()
      this.loadItems()
    },
    created() {
      window.addEventListener("keydown", this.scanBarcode);
      window.addEventListener("keydown", this.handlerSearchProducts);
      window.addEventListener("keydown", this.handleMultipleListPriceKeydown);
    },
    destroyed() {
      window.removeEventListener("keydown", this.scanBarcode);
      window.removeEventListener("keydown", this.captureBarcode);

      window.removeEventListener("keydown", this.handlerSearchProducts);
      window.removeEventListener("keydown", this.handleMultipleListPriceKeydown);

      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      getMultipleListPriceAction(index) {
        var action = this.$refs['actionPriceItem_' + index]
        return Array.isArray(action) ? action[0] : action
      },
      focusMultipleListPriceAction(index) {
        var action = this.getMultipleListPriceAction(index)
        if(!action || typeof action.focus !== 'function') return
        this.multipleListPriceActiveIndex = index
        action.focus()
      },
      focusFirstMultipleListPriceAction() {
        this.$nextTick(() => this.focusMultipleListPriceAction(0))
      },
      onMultipleListPriceHidden() {
        this.multipleListPriceActiveIndex = -1
        this.multipleListPriceSelecting = false
      },
      multipleListPriceRowClass(item, type) {
        return type === 'row' && item === this.tableMultipleListPrice.items[this.multipleListPriceActiveIndex]
          ? 'app-table-row-active'
          : ''
      },
      loadMultipleListPriceIvaPreference() {
        try {
          const saved = localStorage.getItem('sales_multiple_list_price_show_iva')
          if(saved !== null) {
            this.showMultipleListPriceWithIva = saved === 'true'
          }
        } catch (e) { /* localStorage no disponible: conserva el default */ }
      },
      saveMultipleListPriceIvaPreference() {
        try {
          localStorage.setItem('sales_multiple_list_price_show_iva', String(this.showMultipleListPriceWithIva))
        } catch (e) { /* La preferencia es opcional. */ }
        this.configFieldsTable()
      },
      getMultipleListPriceWithIva(item) {
        if(!item || !item.amount) return 0
        return this.calcPriceIva(item.amount.amount_total, item.amount.aliquot_iva)
      },
      handleMultipleListPriceKeydown(event) {
        if(!this.modal.multipleListPrice.active || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return

        var activeIndex = this.tableMultipleListPrice.items.findIndex((item, index) => {
          var action = this.getMultipleListPriceAction(index)
          var element = action && (action.$el || action)
          return element === document.activeElement
        })
        var currentIndex = activeIndex === -1 ? this.multipleListPriceActiveIndex : activeIndex
        if(currentIndex < 0) currentIndex = 0

        var nextIndex = event.key === 'ArrowDown'
          ? Math.min(currentIndex + 1, this.tableMultipleListPrice.items.length - 1)
          : Math.max(currentIndex - 1, 0)

        event.preventDefault()
        this.focusMultipleListPriceAction(nextIndex)
      },
      normalizeNumericValue(value, fallback = 0) {
        if(value === null || value === undefined || value === '') {
          return fallback
        }
        if(typeof value === 'number') {
          return isNaN(value) ? fallback : value
        }
        let str = String(value).trim()
        if(!str) {
          return fallback
        }
        str = str.replace(/\s/g, '')
        if(str.includes(',') && str.includes('.')) {
          str = str.replace(/\./g, '').replace(',', '.')
        } else if(str.includes(',')) {
          str = str.replace(',', '.')
        }
        const num = parseFloat(str)
        return isNaN(num) ? fallback : num
      },
      normalizeAmountForDisplay(value) {
        return Math.round(this.normalizeNumericValue(value, 0) * 100) / 100
      },
      productItemControlsStock(item) {
        return !item || !item.product || item.product.control_stock !== false
      },
      resetPriceContext() {
        this.modal.multipleListPrice.active = false
        this.modal.facility.active = false
        this.crud.form.detail_register.forceRenderSelectProduct = Math.random()
        this.loadProducts(null)
      },
      showMissingPriceWarning() {
        this.$awn.warning("El producto no tiene precio en la lista seleccionada.")
      },
      configFieldsTable() {
        // TABLE DETAILS
        // Anchos fijos (+ table-colgroup/:fixed="true") para que la
        // columna de producto sea la única que ceda espacio (trunca con
        // title) y el resto (cantidad, importes) no quede amontonado.
        // La alineación (derecha/centro) es solo de desktop: en mobile
        // (modo stacked) alignClass() la resuelve a la izquierda, así el
        // <td> nunca llega con text-right/text-center puesto — si no, la
        // etiqueta queda a la izquierda (por nuestro override) pero el
        // valor sigue empujado a la derecha por su propia clase.
        this.tableDetailNewOrder = []
        this.tableDetailNewOrder.push({key: 'code', label: 'Código', class:"align-middle text-truncate", width:"115px"})
        this.tableDetailNewOrder.push({key: 'product', label: 'Producto', class:"align-middle"})
        this.tableDetailNewOrder.push({key: 'list', label: 'Lista', class:"align-middle " + this.alignClass('text-center'), width:"70px"})
        this.tableDetailNewOrder.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-center'), width:"90px"})
        this.tableDetailNewOrder.push({key: 'amount', label: 'Importe', class:"align-middle " + this.alignClass('text-right'), width:"115px"})
        if(!this.notIva) {
          this.tableDetailNewOrder.push({key: 'amount_iva', label: 'Importe c/IVA', class:"align-middle " + this.alignClass('text-right'), width:"130px"})
        }

        if(this.showDiscount) {
          this.tableDetailNewOrder.push({key: 'discount', label: 'Descuento', class:"align-middle " + this.alignClass('text-right'), width:"140px"})
        }

        this.tableDetailNewOrder.push({key: 'total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"125px"})
        this.tableDetailNewOrder.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"50px"})

        // TABLE MULTIPLE PRICE
        this.tableMultipleListPrice.fields = []
        var showIvaOnMultipleListPrice = this.showMultipleListPriceWithIva && !this.notIva
        this.tableMultipleListPrice.fields.push({key: 'list', label: 'Lista', class:"align-middle", width:showIvaOnMultipleListPrice ? "27%" : "35%"})
        this.tableMultipleListPrice.fields.push({key: 'price_list', label: 'Precio base', class:"align-middle " + this.alignClass('text-right'), width:showIvaOnMultipleListPrice ? "13%" : "15%"})
        this.tableMultipleListPrice.fields.push({key: 'price_public', label: 'Precio de lista', class:"align-middle " + this.alignClass('text-right'), width:showIvaOnMultipleListPrice ? "13%" : "15%"})
        this.tableMultipleListPrice.fields.push({key: 'desc', label: 'Descuento', class:"align-middle " + this.alignClass('text-right'), width:showIvaOnMultipleListPrice ? "9%" : "10%"})
        this.tableMultipleListPrice.fields.push({key: 'price_desc', label: 'Precio final', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        if(showIvaOnMultipleListPrice) {
          this.tableMultipleListPrice.fields.push({key: 'price_iva', label: 'Precio c/IVA', class:"align-middle " + this.alignClass('text-right'), width:"15%"})
        }
        this.tableMultipleListPrice.fields.push({key: 'action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"10%"})
      },
      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data                  
          this.configurations = data                          
        })      
      },       
      loadItems() {          
        if(this.detailEdit) {
          this.detailEdit.forEach(element => {            
            var arrItem = { 
              product: element.product, 
              quantity: parseFloat(element.quantity), 
              quantityOld: parseFloat(element.quantity),
              currency: element.currency,                        
              amount: parseFloat(element.amount),   
              discount: (element.itemDetail ? parseFloat(element.itemDetail.percentage_discount) : 0),                       
              unit_measurement: element.unit_measurement,
              price_list: element.price_list
            }

            this.crud.form.detail.push(arrItem)                  
            this.crud.form.editOrder = true
          });
          
          this.$emit('load-detail', this.crud.form.detail)
        }
      },      
      loadProducts (object, forceRenderSelectProduct = false) {
        if(object){
          // FindObject valida la elección en forma asíncrona. Si Enter se
          // repite antes de que terminen esas validaciones, puede emitir el
          // mismo producto varias veces; sólo la primera debe continuar.
          if(this.productSelectionPendingId === object.id) {
            return
          }
          this.productSelectionPendingId = object.id
          // Invalida cualquier precio pendiente apenas se confirma otro
          // producto. Para productos sin variantes, el overlay se muestra
          // antes de iniciar la consulta para que nunca pueda agregarse el
          // precio de la selección anterior.
          const productSelectionSequence = ++this.priceRequestSequence
          this.priceLoading = false
          this.crud.form.detail_register.product = object
          this.crud.form.detail_register.product_id = object.id     
          
          this.crud.form.detail_register.color = null
          this.crud.form.detail_register.waist = null
                    
          this.crud.form.detail_register.amount = 0
          this.crud.form.detail_register.amount_raw_internal = undefined
          this.crud.form.detail_register.currency = null
          this.crud.form.detail_register.opt_color = []
          this.crud.form.detail_register.opt_waist = []

          if(forceRenderSelectProduct) {
            this.crud.form.detail_register.forceRenderSelectProduct = object.id
          }          

          this.crud.form.detail_register.selectedProduct = null             
          this.crud.form.detail_register.unit_measurement = object.unit_measurement_sale
          this.crud.form.detail_register.unit_measurement_id = object.unit_measurement_sale.id
                              
          if(object.colors_waist.length) {
            var colorUnique = this.getColorWaistUnique          
            if(colorUnique) {
              colorUnique.forEach(element => {
                this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})
              });
            }
            return false 
          } 
          
          if(object.colors.length) {
            var detail_register = []
            var colorUnique = object.colors          
                        
            if(colorUnique) {              
              colorUnique.forEach(element => {  
                if(this.editing.status) {
                  this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})
                } else {  
                  if(!this.price_list_id) {
                    this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})
                  } else {
                    if(this.showItemCrudFacilityColors(element)) {               
                      var variantSelect = element                        
                      variantSelect['source'] = 'colors'

                      if(this.customer_id) {                    
                        var result = serviceAPI.obtenerPrecioProducto({
                          product: variantSelect,
                          customer_id: this.customer_id,
                          price_list_id: this.price_list_id,
                          reason_id: this.reason_id,
                          disable_customer_price_list_fallback: this.disableCustomerPriceListFallback
                        })        
                        result.then((response) => {
                          var data = response.data   

                          if(!data.undefined) {                          
                            detail_register.push({
                              quantity: 0,
                              currency: data.list.currency,
                              amount: data.price_simple,
                              item: data.color,
                              itemName: data.color.name,
                              itemOrder: 0,
                              product: data,
                              id: element.id,
                              discount: 0,
                              unit_measurement: object.unit_measurement_sale,
                            })                    
                          }                                    
                        })             
                      } else {                      
                        detail_register.push({
                          quantity: 0,
                          currency: null,
                          amount: 0,
                          item: null,
                          itemName: '',
                          itemOrder: 0,
                          product: null,
                          id: 0,
                          discount: 0,
                          unit_measurement: null,
                        })                                            
                      }    
                    }

                    this.crud.facility.type = 'colors'
                    this.crud.facility.totalItems = object.colors.length
                    this.crud.facility.products = detail_register

                    this.modal.facility.active = true
                    this.modal.facility.title = "Cargar Colores" 
                  }         
                }                                                
              });              
            }    
            return false                              
          }

          if(object.waist.length) {
            var detail_register = []
            var waistUnique = object.waist

            if(waistUnique) {
              waistUnique.forEach(element => {  
                if(this.editing.status) {
                  this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
                } else {
                  if(!this.price_list_id) {
                    this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
                  } else {
                    if(this.showItemCrudFacilityWaist(element)) {               
                      var variantSelect = element                        
                      variantSelect['source'] = 'waist'

                      if(this.customer_id) {                    
                        var result = serviceAPI.obtenerPrecioProducto({
                          product: variantSelect,
                          customer_id: this.customer_id,
                          price_list_id: this.price_list_id,
                          reason_id: this.reason_id,
                          disable_customer_price_list_fallback: this.disableCustomerPriceListFallback
                        })        
                        result.then((response) => {
                          var data = response.data   
                          
                          if(!data.undefined) {     
                            detail_register.push({
                              quantity: 0,
                              currency: data.list.currency,
                              amount: data.price_simple,
                              item: data.waist,
                              itemName: data.waist.name,
                              itemOrder: data.waist.order,
                              product: data,
                              id: element.id,
                              discount: 0,
                              unit_measurement: object.unit_measurement_sale,
                            })                    
                          }                                    
                        })             
                      } else {                      
                        detail_register.push({
                          quantity: 0,
                          currency: null,
                          amount: 0,
                          item: null,
                          itemName: '',
                          itemOrder: 0,
                          product: null,
                          id: 0,
                          discount: 0,
                          unit_measurement: null,
                        })                                            
                      }    
                    }

                    this.crud.facility.type = 'waist'
                    this.crud.facility.totalItems = object.waist.length
                    this.crud.facility.products = detail_register

                    this.modal.facility.active = true
                    this.modal.facility.title = "Cargar Talles" 
                  }
                }
              });
            }
            return false
          }    
          
          if(!object.colors_waist.length && !object.colors.length && !object.waist.length) {            
            this.priceLoading = true
            this.$nextTick(() => {
              window.requestAnimationFrame(() => {
                if(productSelectionSequence !== this.priceRequestSequence || this.crud.form.detail_register.product !== object) {
                  return
                }
                this.selectedProduct()
              })
            })
                        
            setTimeout(()=> {
              if(this.$refs.inputQuantity) {     
                this.$refs.inputQuantity.focus()         
                this.$refs.inputQuantity.select()
              }
            },500)
          }

        } else {                    
          this.priceRequestSequence++
          this.priceLoading = false
          this.productSelectionPendingId = null
          this.crud.form.detail_register.product_id = 0                  
          this.crud.form.detail_register.product = null
          
          this.crud.form.detail_register.color = null
          this.crud.form.detail_register.waist = null                        
          this.crud.form.detail_register.quantity = this.quantityProducts
          this.crud.form.detail_register.amount = 0
          this.crud.form.detail_register.amount_raw_internal = undefined
          this.crud.form.detail_register.discount = 0
          this.crud.form.detail_register.currency = null
          this.crud.form.detail_register.opt_color = []
          this.crud.form.detail_register.opt_waist = []   
          this.crud.form.detail_register.selectedProduct = null
          this.crud.form.detail_register.unit_measurement = null
          this.crud.form.detail_register.unit_measurement_id = 0

          this.crud.form.detail_register.button.title = "Agregar Item (CTRL + SHIFT + '+')"
          this.crud.form.detail_register.button.icon = "fa fa-plus"
          this.crud.form.detail_register.button.variant = "success"          
        }
      },    

      // SELECCION PRODUCTO-VARIEDAD 
      selectColorCombinado(item) {        
        this.crud.form.detail_register.color = item
        this.crud.form.detail_register.waist = null

        this.crud.form.detail_register.opt_waist = []
        var waistUnique = this.getWaistByColor          
        if(waistUnique) {
          waistUnique.forEach(element => {
            this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
          });
        }         
      },
      selectWaistCombinado(item) {
        this.crud.form.detail_register.waist = item
        this.selectedProduct()        
      },      
      selectColorSimple(item) {
        this.crud.form.detail_register.color = item
        this.selectedProduct()        
      },
      selectWaistSimple(item) {
        this.crud.form.detail_register.waist = item      
        this.selectedProduct()        
      },  

      // PRODUCTO/VARIEDAD SELCCIONADA
      selectedProduct() {        
        const requestSequence = ++this.priceRequestSequence
        this.priceLoading = true
        var variantSelect = null

        if(this.crud.form.detail_register.product) {
          if(this.haveOnlyProduct) {
            variantSelect = this.crud.form.detail_register.product
            variantSelect['source'] = 'product'
          } else {
            if(this.haveColorsWaist) {
              if(this.crud.form.detail_register.color && this.crud.form.detail_register.waist) {
                this.crud.form.detail_register.product.colors_waist.forEach(element => {                
                  if( element.colors_id == this.crud.form.detail_register.color.code.id && 
                      element.waist_id == this.crud.form.detail_register.waist.code.id ) {                                      
                      variantSelect = element
                      variantSelect['unit_measurement_purchase_id'] = this.crud.form.detail_register.product.unit_measurement_purchase_id
                      variantSelect['control_stock'] = this.crud.form.detail_register.product.control_stock
                      variantSelect['source'] = 'colors_waist'
                  }
                });
              }            
            } else {
              if(this.haveOnlyColors) {                
                if(this.crud.form.detail_register.color) {                  
                  this.crud.form.detail_register.product.colors.forEach(element => {                                       
                    if( element.colors_id == this.crud.form.detail_register.color.code.id ) {                                      
                        variantSelect = element
                        variantSelect['unit_measurement_purchase_id'] = this.crud.form.detail_register.product.unit_measurement_purchase_id
                        variantSelect['control_stock'] = this.crud.form.detail_register.product.control_stock
                        variantSelect['source'] = 'colors'
                    }
                  })
                }
              } else {
                if(this.haveOnlyWaist) {
                  if(this.crud.form.detail_register.waist) {
                    this.crud.form.detail_register.product.waist.forEach(element => {                   
                      if( element.waist_id == this.crud.form.detail_register.waist.code.id ) {                                      
                          variantSelect = element
                          variantSelect['unit_measurement_purchase_id'] = this.crud.form.detail_register.product.unit_measurement_purchase_id
                          variantSelect['control_stock'] = this.crud.form.detail_register.product.control_stock
                          variantSelect['source'] = 'waist'
                      }
                    })
                  }
                }            
              }          
            }     
          }             
        }

        if(variantSelect && this.customer_id) {          
          var listPriceQuery = 0
          if(!(this.editPrice && this.editing.status)) {          
            listPriceQuery = this.price_list_id;
          } else {
            listPriceQuery = this.editing.list.id
          }

          this.priceLoading = true
          var result = serviceAPI.obtenerPrecioProducto({
            product: variantSelect,
            customer_id: this.customer_id,
            price_list_id: listPriceQuery,
            reason_id: this.reason_id,
            disable_customer_price_list_fallback: this.disableCustomerPriceListFallback
          })        
          result.then((response) => {
            if(requestSequence !== this.priceRequestSequence) {
              return
            }
            this.priceLoading = false

            var data = response.data
            this.tableMultipleListPrice.items = []
            if(Array.isArray(data)) {
              const availablePrices = data.filter(element => element && !element.undefined && element.amount)
              if(!availablePrices.length) {
                this.productSelectionPendingId = null
                this.crud.form.detail_register.selectedProduct = null
                this.showMissingPriceWarning()
                return
              }

              if(availablePrices.length === 1) {
                this.crud.form.detail_register.selectedProduct = availablePrices[0]
                return
              }

              availablePrices.forEach(element => {
                if(element.amount) {
                  this.tableMultipleListPrice.items.push(element)
                }
              });
            } else {
              if(!data || data.undefined || !data.amount) {
                this.productSelectionPendingId = null
                this.crud.form.detail_register.selectedProduct = null
                this.showMissingPriceWarning()
                return
              }
              this.tableMultipleListPrice.items.push(data)
            }

            if (Array.isArray(data)) {              
              if(!this.crud.form.detail_register.selectedProduct) {              
                this.modal.multipleListPrice.title = "Selección de Lista de Precios"
                this.modal.multipleListPrice.code = variantSelect.code
                this.modal.multipleListPrice.product = variantSelect.name
                this.modal.multipleListPrice.active = true      
              }              
            } else {
              this.crud.form.detail_register.selectedProduct = data
            }                       
          })
          .catch(error => {
            if(requestSequence !== this.priceRequestSequence) {
              return
            }
            this.priceLoading = false
            this.productSelectionPendingId = null
            this.crud.form.detail_register.selectedProduct = null
            this.$awn.alert(Error.showError(error))
          })
        } else {                      
          this.priceLoading = false
          this.crud.form.detail_register.selectedProduct = null
        }    
      }, 
      selectMultipleListPrice(item) {                
        if(this.multipleListPriceSelecting) {
          return
        }
        this.multipleListPriceSelecting = true
        this.crud.form.detail_register.selectedProduct = item
        this.modal.multipleListPrice.active = false

        setTimeout(()=> {
          if(this.$refs.inputQuantity) {     
            this.$refs.inputQuantity.focus()         
            this.$refs.inputQuantity.select()
          }
        },500)        
      },
      cancelMultipleListPrice() {
        this.productSelectionPendingId = null
        this.modal.multipleListPrice.active = false
      },      
      sumDiscountPrice(amount, desc, item = null, action = 'viewCalc') {                  
        if(item && item.unit_measurement_purchase && item.unit_measurement_sale && item.unit_measurement_purchase.id != item.unit_measurement_sale.id) {        
          if(action == 'viewCalc') {                       
            if(parseFloat(item.amount.amount_initial) == parseFloat(amount)) {
              return parseFloat(item.amount.amount_initial)
            } else {
              if(desc) {
                var base1 = (100 - parseFloat(desc)) / 100                
                if(parseFloat(base1) == 0) {                            
                  return parseFloat(amount)
                } else {                              
                  return parseFloat(amount) / base1
                }                        
              } else {            
                return parseFloat(amount)
              }
            }          
          } 
          
          if(action == 'formEdit') {           
            return parseFloat(amount)
          }
        } else {    
          if(action == 'viewCalc') {        
            if(desc) {
              var base2 = (100 - parseFloat(desc)) / 100                
              if(parseFloat(base2) == 0) {                            
                return parseFloat(amount)
              } else {              
                return parseFloat(amount) / base2
              }                        
            } else {
              return parseFloat(amount)
            }
          }

          if(action == 'formEdit') {           
            return parseFloat(amount)
          }          
        }     
      },
      calcPriceIva(amount, iva=0, surcharge=0) {        
        var price = parseFloat(amount) || 0
        if(parseFloat(iva) > 0) {
          price = price + ((price * parseFloat(iva)) / 100)
        }
        if(parseFloat(surcharge) > 0) {
          price = parseFloat(price) + ((parseFloat(price) * parseFloat(surcharge)) / 100)
        }
        return price
      },
      currentDetailRawAmount() {
        return this.parameters.salePriceCalc && this.crud.form.detail_register.amount_raw_internal !== undefined
          ? this.crud.form.detail_register.amount_raw_internal
          : this.crud.form.detail_register.amount
      },
      calcSurchargePriceIva(amount, iva, surcharge) {
        if(!this.parameters.salePriceCalc) return this.calcPriceIva(amount, iva, surcharge)
        const netWithSurcharge = Math.round((parseFloat(amount) || 0) * (1 + (parseFloat(surcharge) || 0) / 100) * 100) / 100
        return this.calcPriceIva(netWithSurcharge, iva)
      },
      getDetailItemAliquotIva(item) {
        if(!item || !item.product) return 0
        if(item.product.amount && item.product.amount.aliquot_iva !== undefined) return item.product.amount.aliquot_iva
        var condition = this.ivaConditions.find(value => value.id == item.product.erp_iva_condition_id)
        return condition ? condition.aliquot : 0
      },
      hasDetailItemIva(item) {
        return parseFloat(this.getDetailItemAliquotIva(item)) > 0
      },
      getDetailIvaAmount(item) {
        const amount = parseFloat(item && item.amount) || 0
        const iva = parseFloat(this.getDetailItemAliquotIva(item)) || 0
        if(this.parameters.salePriceCalc) {
          // Diferencia entre los importes que se muestran (c/IVA y neto, ambos
          // en centavos), para que el desglose del popover sume a la vista.
          return (Math.round(amount * (1 + iva / 100) * 100) - Math.round(amount * 100)) / 100
        }
        return amount * iva / 100
      },
      getDetailUnitDiscount(item) {
        return (parseFloat(item && item.amount) || 0) * (parseFloat(item && item.discount) || 0) / 100
      },
      getDetailUnitFinal(item) {
        return (parseFloat(item && item.amount) || 0) - this.getDetailUnitDiscount(item)
      },
      formatDetailPrice(item, amount) {
        if(!item || !item.currency) return ''
        var displayedAmount = this.calcPriceIva(amount, this.getDetailItemAliquotIva(item))
        return Intl.NumberFormat('es-AR', {style:'currency', currency:item.currency.code}).format(displayedAmount)
      },
      formatDetailNetPrice(item, amount) {
        return Intl.NumberFormat('es-AR', {style:'currency', currency:item.currency.code}).format(amount)
      },
      getVisibleLineAmounts(item) {
        const amount = parseFloat(item.amount) || 0
        const quantity = Math.round((parseFloat(item.quantity) || 0) * 100) / 100
        const discount = Math.round((parseFloat(item.discount) || 0) * 100) / 100
        const iva = this.notIva ? 0 : (parseFloat(this.getDetailItemAliquotIva(item)) || 0)
        const unitCents = Math.round(amount * (1 + iva / 100) * 100)
        const subtotalCents = Math.round(unitCents * quantity)
        const discountCents = Math.round(subtotalCents * discount / 100)
        return { total: (subtotalCents - discountCents) / 100, discount: discountCents / 100 }
      },
      formatDetailDiscount(item) {
        if(this.parameters.salePriceCalc) {
          return this.formatDetailNetPrice(item, this.getVisibleLineAmounts(item).discount)
        }
        return this.notIva
          ? this.formatDetailNetPrice(item, this.getRegDiscount(item))
          : this.formatDetailPrice(item, this.getRegDiscount(item))
      },
      formatDetailTotal(item) {
        if(this.parameters.salePriceCalc) {
          return this.formatDetailNetPrice(item, this.getVisibleLineAmounts(item).total)
        }
        return this.notIva
          ? this.formatDetailNetPrice(item, this.getRegTotals(item))
          : this.formatDetailPrice(item, this.getRegTotals(item))
      },
      getDetailQuantityLabel(item) {
        var quantity = parseFloat(item.quantity || 0).toFixed(2)
        return quantity + (item.unit_measurement ? ' ' + item.unit_measurement.reference : '')
      },

      // ABM MAIN DETAILS
      // shouldFocusSearch: al agregar, devuelve el foco al buscador de productos
      // (para cargar varios productos seguidos sin volver a clickear).
      // viaKeyboard: el alta se disparó por teclado (Enter, Ctrl+Shift+"+"), no
      // por click de mouse; ver focusProductSearch() para el porqué.
      addItem(shouldFocusSearch = false, viaKeyboard = false) {
        if(this.priceLoading) {
          return false
        }

        // producto
        if(!this.crud.form.detail_register.selectedProduct) {
          this.$awn.alert('No se seleccionó el producto')          
          return false
        }
                
        // cantidad
        if (this.crud.form.detail_register.quantity == undefined || this.crud.form.detail_register.quantity.toString() == '' || parseFloat(this.crud.form.detail_register.quantity)<=0) {
          this.$awn.alert('La cantidad debe ser mayor a cero')          
          return false          
        }
          
        // amount
        if(this.crud.form.detail_register.amount == undefined || this.crud.form.detail_register.amount.toString() == '') {
          this.crud.form.detail_register.amount = 0
        } else {
          if (parseFloat(this.crud.form.detail_register.amount)<0) {                   
            this.$awn.alert('El precio no puede ser menor a cero')          
            return false          
          }
        }

        // descuento
        if(this.crud.form.detail_register.discount == undefined || this.crud.form.detail_register.discount.toString() == '') {
          this.crud.form.detail_register.discount = 0
        } else {
          if (parseFloat(this.crud.form.detail_register.discount)<0) {      
            this.$awn.alert('El descuento no puede ser menor a cero')          
            return false          
          }
        }
        
        // stock
        if(!this.validStockItem()) {
          this.$awn.alert('Stock Insuficiente') 
          return false
        }

        // duplicados
        if(this.validItemDuplicated) {
          if(!this.validDuplicatedItem()) {
            this.$awn.alert('Item Duplicado')
            return false        
          }
        }

        // validar condicion de iva
        if(this.crud.form.detail_register.selectedProduct && !this.crud.form.detail_register.selectedProduct.erp_iva_condition_id) {
            this.$awn.alert('No se cargó Alícuota de IVA para el producto')
            return false        
        }

        var arrItem = { 
          product: this.crud.form.detail_register.selectedProduct,
          quantity: parseFloat(this.crud.form.detail_register.quantity),
          quantityOld: parseFloat(this.crud.form.detail_register.quantityOld),
          currency: this.crud.form.detail_register.currency,
          amount: (this.parameters.salePriceCalc && this.crud.form.detail_register.amount_raw_internal !== undefined)
            ? this.crud.form.detail_register.amount_raw_internal
            : parseFloat(this.crud.form.detail_register.amount),
          discount: parseFloat(this.crud.form.detail_register.discount),
          unit_measurement: this.crud.form.detail_register.unit_measurement,
          price_list: this.crud.form.detail_register.price_list
        }

        this.crud.form.detail.push(arrItem)
        this.$emit('load-detail', this.crud.form.detail)
        
        this.crud.form.detail_register.forceRenderSelectProduct = Math.random()
        this.loadProducts(null)                                    
        
        this.crud.form.detail_register.button.editing = false

        if(shouldFocusSearch) {
          this.focusProductSearch(viaKeyboard)
        }

        /*
        setTimeout(()=> {
          if(this.$refs.actionItem_0) {
            this.$refs.actionItem_0.focusToggler()
          }
        },100)
        */
      },
      focusProductSearch(viaKeyboard = false) {
        this.$nextTick(() => {
          var searchProducts = this.$refs.searchProducts
          if(searchProducts && searchProducts.$el) {
            searchProducts.restoreLastSearch()
            // Si el foco llega por teclado (Enter, Ctrl+Shift+"+"), el keyup
            // de esa(s) misma(s) tecla(s) puede llegar recién acá enfocado.
            // Le pedimos al buscador que ignore keyups hasta que el usuario
            // tipee algo de verdad (primer keydown propio sobre el input).
            if(viaKeyboard) searchProducts.ignoreSearchKeyup()
            var input = searchProducts.$el.querySelector('input')
            if(input) input.focus()
          }
        })
      },
      handleAddButtonClick(event) {
        // Un click "real" de mouse trae detail >= 1 (cantidad de clicks).
        // La activación del botón por teclado (Enter/Espacio) dispara un
        // click sintético con detail === 0: así distinguimos el origen sin
        // depender de un segundo listener de keydown, que en los navegadores
        // dispara IGUAL el click nativo del botón aunque se haga preventDefault.
        var viaKeyboard = !!event && event.detail === 0
        this.addItem(true, viaKeyboard)
      },
      editItem (item, index) {    
        this.crud.form.detail_register.editing = true
        this.crud.form.detail_register.forceRenderPrice++
        this.crud.form.detail_register.quantity = item.quantity
        this.crud.form.detail_register.quantityOld = item.quantityOld
        this.crud.form.detail_register.discount = item.discount      
        this.crud.form.detail_register.price_list = item.price_list
        
        // le quitamos la validacion if(this.editPrice)  que viene seteado como un parametro del componente
        this.editing.status = true
        this.editing.price = item.amount
        this.editing.unit_measurement = item.unit_measurement
        this.editing.list = item.price_list ? item.price_list : item.product.list
                           
        if(item.product.source == 'product') {             
          this.crud.form.detail_register.product_id = item.product.id
          this.crud.form.detail_register.forceRenderSelectProduct = item.product.id    
          
          this.crud.form.detail_register.editing = false
        } else {          
          if(item.product.source == 'colors_waist') {
            this.crud.form.detail_register.product_id = item.product.products_id      
            this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
            
            setTimeout(()=>{
              this.crud.form.detail_register.color = {code:item.product.color, label:item.product.color.name}
              this.selectColorCombinado(this.crud.form.detail_register.color)

              setTimeout(()=>{
                this.crud.form.detail_register.waist = {code:item.product.waist, label:item.product.waist.name}                
                this.selectWaistCombinado(this.crud.form.detail_register.waist) 

                this.crud.form.detail_register.editing = false
              },1000)              
            },1000)                        
          } else {
            if(item.product.source == 'colors') {
              this.crud.form.detail_register.product_id = item.product.products_id
              this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
                                          
              setTimeout(()=>{                
                this.crud.form.detail_register.color = {code:item.product.color, label:item.product.color.name}
                this.selectColorSimple(this.crud.form.detail_register.color)

                this.crud.form.detail_register.editing = false
              },1000)                            
            }
            if(item.product.source == 'waist') {
              this.crud.form.detail_register.product_id = item.product.products_id
              this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
              
              setTimeout(()=>{                
                this.crud.form.detail_register.waist = {code:item.product.waist, label:item.product.waist.name}                
                this.selectWaistSimple(this.crud.form.detail_register.waist) 

                this.crud.form.detail_register.editing = false
              },1000)                            
            }
          }
        }
        
        this.crud.form.detail_register.button.title = "Editar Item (CTRL + SHIFT + '+')"
        this.crud.form.detail_register.button.icon = "fa fa-save"
        this.crud.form.detail_register.button.variant = "warning"
        this.crud.form.detail_register.button.editing = true
                     
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      deleteItem (index) {
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },

      // Texto plano (sin markup) para el title del tooltip de la celda de
      // producto, que trunca con text-truncate en la tabla.
      getProductCellText(item) {
        var text = item.product.name
        if(item.product.color) {
          text += ' - ' + item.product.color.name
        }
        if(item.product.waist && item.product.waist.name) {
          text += ' - ' + item.product.waist.name
        }
        return text
      },

      // CALCULA DISCOUNT
      getRegDiscount(item) {
        var totalDiscount = 0
        if(parseFloat(item.discount) > 0) {
          totalDiscount = parseFloat(item.quantity) * (( parseFloat(item.amount) * parseFloat(item.discount) ) / 100)
        }        
        return totalDiscount
      },
      getRegSubTotals(item) {
        var subtotal = parseFloat(item.quantity) * parseFloat(item.amount)
        return subtotal
      },       
      getRegTotals(item) {
        var total = 0
        if(parseFloat(item.discount) > 0) {
          var discount = (parseFloat(item.amount) * parseFloat(item.discount)) / 100
          var amount = parseFloat(item.amount) - parseFloat(discount)

          total = parseFloat(item.quantity) * parseFloat(amount)
        } else {
          total = parseFloat(item.quantity) * parseFloat(item.amount)
        }
        return total
      },      

      // VALIDA STOCK
      validStockItem() {
        var status = true
        var exemptFromStockControl = this.crud.form.detail_register.selectedProduct &&
                                      this.crud.form.detail_register.selectedProduct.control_stock === false
        if(this.validStock && !exemptFromStockControl) {
          if(this.crud.form.editOrder) {
            if(this.crud.form.detail_register.selectedProduct) {                   
              if(this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_id == this.crud.form.detail_register.unit_measurement.id) {
                let stockProduct = 0
                if(this.moduleDepositActive) {
                  stockProduct = parseFloat(this.crud.form.detail_register.selectedProduct.stock)
                } else {
                  stockProduct = parseFloat(this.crud.form.detail_register.selectedProduct.stock) + parseFloat(this.crud.form.detail_register.quantityOld)
                }

                if(this.crud.form.detail_register.quantity > stockProduct) {          
                  this.crud.form.detail_register.quantity = stockProduct              
                  var status = false
                }
              }
            }
          } else {
            if(this.crud.form.detail_register.selectedProduct) {                          
              if(this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_id == this.crud.form.detail_register.unit_measurement.id) {
                let stockProduct = parseFloat(this.crud.form.detail_register.selectedProduct.stock) 
                if(this.crud.form.detail_register.quantity >  stockProduct) {          
                  this.crud.form.detail_register.quantity = stockProduct
                  var status = false
                }
              }
            }
          }
        }
        return status
      },  
      
      // VALID DUPLICATED
      validDuplicatedItem() {
        var item = this.crud.form.detail_register.selectedProduct
        var status = true
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {                        
            if(element.product.source=='product') {
              if(element.product.id == item.id) {
                status = false
              }              
            } 
            
            if(element.product.source=='colors_waist') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id) {
                status = false
              }              
            }

            if(element.product.source=='colors') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id) {
                   status = false
                 }              
            }

            if(element.product.source=='waist') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id) {              
                  status = false
              }              
            }
          });
        }
        return status
      },     
      
      // FACILITY
      saveFacility() {        
        if(this.crud.facility.products) {
          this.crud.facility.products.forEach(element => {                       
            if(parseFloat(element.quantity)) {                   
              this.crud.form.detail_register.quantity = element.quantity     
              this.crud.form.detail_register.quantityOld = element.quantity             
              this.crud.form.detail_register.selectedProduct = element.product
              this.crud.form.detail_register.currency = element.currency
              this.crud.form.detail_register.amount = element.amount
              this.crud.form.detail_register.discount = element.discount
              this.crud.form.detail_register.unit_measurement = element.unit_measurement
              this.addItem()
            } 
          });

          this.cancelFacility()
        }        
      },
      cancelFacility() {
        this.crud.form.detail_register.forceRenderSelectProduct = 0
        this.loadProducts(null)                                    
        
        this.crud.form.detail_register.button.editing = false 

        this.modal.facility.active = false
      },
      showItemCrudFacilityColors(item) {
        var status = true
       
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {    
            if(element.product.source == 'colors') {
              if(element.product.id == item.id) {
                status = false
              }
            }
          });
        }
        return status
      },
      showItemCrudFacilityWaist(item) {
        var status = true
       
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {    
            if(element.product.source == 'waist') {
              if(element.product.id == item.id) {
                status = false
              }
            }
          });
        }
        return status
      },      

      // LOAD EQUIVALENCES
      loadEquivalences() {        
        this.arr.equivalences = []

        if(this.crud.form.detail_register.selectedProduct) {        
          if(this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default) {            
            var result = serviceAPI.obtenerEquivalencesAvailable({
              unit_measurement_id: this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default.id,
            })

            result.then((response) => {
              var data = response.data
              this.arr.equivalences = data
            })      
          }
        }
      },
      setUnitMeasurementAlternativeRecalculePrice(element) {        
        var result = serviceAPI.recalculePriceByUnitMeasurementAlternative({
          products_id: this.crud.form.detail_register.selectedProduct.id,
          price: this.crud.form.detail_register.amount_initial,
          uni: this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default.id,
          unr: element.id,
        })

        result.then((response) => {
          var data = response.data
          this.crud.form.detail_register.amount = data
          
          this.crud.form.detail_register.unit_measurement = element
          this.crud.form.detail_register.unit_measurement_id = element.id          
        })                  
      },

      // SCAN CAPTURE BARCODE      
      scanBarcode(e) {
        // f3 = 114
        // ctrl + f = 70
        if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
          e.preventDefault();
          e.stopPropagation();

          if(this.modal.barcode.active) {
            this.modal.barcode.active = false
            this.modal.barcode.value = ''
            if (!this.barcodeConfirm) window.removeEventListener('keydown',this.captureBarcode)
          } else {
            this.modal.barcode.active = true
            this.modal.barcode.value = ''
            this.modal.barcode.lastAdded = null
            this.modal.barcode.notFound = ''
            this.modal.barcode.searching = false
            if (this.barcodeConfirm) {
              setTimeout(() => { if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus() }, 300)
            } else {
              window.addEventListener('keydown',this.captureBarcode)
            }
          }
        }
      },
      cancelScanBarcode() {
        this.modal.barcode.active = false
        this.modal.barcode.value = ''
        this.modal.barcode.searching = false
        this.modal.barcode.pendingAdd = false
        if (!this.barcodeConfirm) window.removeEventListener('keydown',this.captureBarcode)
      },
      manualSearchBarcode() {
        const barcode = this.modal.barcode.value.trim()
        if (barcode.length >= 1 && !this.modal.barcode.searching) {
          this.searchProductByBarcode(barcode)
        }
      },
      _addFromBarcode() {
        const name = this.crud.form.detail_register.product ? this.crud.form.detail_register.product.name : ''
        const qty  = this.modal.barcode.quantity
        this.crud.form.detail_register.quantity = qty
        this.addItem()
        this.modal.barcode.lastAdded  = { name, quantity: qty }
        this.modal.barcode.notFound   = ''
        this.modal.barcode.value      = ''
        this.modal.barcode.searching  = false
        this.modal.barcode.quantity   = 1
        this.$nextTick(() => { if (this.$refs.barcodeInput) { this.$refs.barcodeInput.focus(); this.$refs.barcodeInput.select() } })
      },
      captureBarcode(e) {
        if (!this.modal.barcode.active) return;

        if (e.key.length === 1) {
          this.modal.barcode.value += e.key;

          clearTimeout(this.modal.barcode.timeout);
          this.modal.barcode.timeout = setTimeout(() => {
            const barcode = this.modal.barcode.value.trim();
            this.modal.barcode.value = '';
            this.modal.barcode.active = false;

            if (barcode.length >= 3) {
              this.searchProductByBarcode(barcode);
            }

          }, this.modal.barcode.scanDelay);
        }
      },
      searchProductByBarcode(barcode) {
        if (this.barcodeConfirm) {
          this.modal.barcode.searching = true
          this.modal.barcode.lastAdded = null
          this.modal.barcode.notFound  = ''
        }

        var result = serviceAPI.obtenerProductos({
          filter: barcode,
          where: [{field: 'm_products.active', condition: true}],
        })

        result.then((response) => {
          var data = response.data

          if(data && data.length>0) {
            var product = data[0]

            var result1 = serviceAPI.mostrarProducto(product.id, {
              filter: barcode,
              where: [{field: 'm_products.active', condition: true}],
            })

            result1.then((response1) => {
              var objProduct = response1.data

              if (this.barcodeConfirm) {
                this.modal.barcode.pendingAdd = true
              }

              this.loadProducts(objProduct, true)

              if (!this.barcodeConfirm) {
                this.crud.form.detail_register.quantity = 1
                if(this.barcodeAddAutomatic && this.haveOnlyProduct) {
                  setTimeout(() => { this.addItem() }, 500)
                }
              }
            })
          } else {
            if (this.barcodeConfirm) {
              this.modal.barcode.searching = false
              this.modal.barcode.notFound  = barcode
              this.modal.barcode.value     = ''
              this.$nextTick(() => { if (this.$refs.barcodeInput) this.$refs.barcodeInput.focus() })
            }
          }
        }).catch(() => {
          if (this.barcodeConfirm) {
            this.modal.barcode.searching = false
            this.modal.barcode.notFound  = barcode
            this.modal.barcode.value     = ''
          }
        })
      },

      // ACCESO DIRECTO BUSCADOR PRODUCTO
      handlerSearchProducts(e) {
        // f4 = 115
        if (e.keyCode === 115) {                   
          e.preventDefault();
                    
          this.$refs.searchProducts.openSearch()
        } 

        // ctrl + shift + "+" = 107
        if (e.ctrlKey && e.shiftKey && e.keyCode === 107) {
          e.preventDefault();

          this.addItem(true, true)
        }
      }
    }
  }
</script>
<style>
  .crud-detail-product-fieldset {
    position: relative;
  }
  .detail-product-price-overlay {
    position: absolute;
    inset: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background: rgba(255, 255, 255, .72);
    color: var(--app-color-text-muted);
    font-size: 12px;
    font-weight: var(--app-font-semibold);
    cursor: wait;
  }
  .multiple-list-price-toolbar {
    display: flex;
    justify-content: flex-end;
    margin: -4px 0 8px;
  }
  .multiple-list-price-toolbar .custom-control-label {
    font-size: 12px;
    color: var(--app-color-text-muted);
  }
  .detail-discount-rate {
    display: inline-block;
    margin-right: 4px;
    color: var(--app-color-text-muted);
    font-size: 10px;
    font-weight: var(--app-font-semibold);
    vertical-align: baseline;
  }
  .detail-discount-rate--info {
    cursor: pointer;
    text-decoration: underline dotted;
    text-underline-offset: 2px;
  }
  .detail-discount-popover {
    min-width: 245px;
    border: 1px solid var(--app-color-border) !important;
    border-radius: 6px;
    box-shadow: var(--app-shadow-sm);
  }
  .detail-discount-popover .popover-body {
    padding: 7px 10px;
    color: var(--app-color-text-secondary);
    font-size: 11px;
  }
  .detail-discount-popover__row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 16px;
    align-items: baseline;
    padding: 3px 0;
  }
  .detail-discount-popover__row + .detail-discount-popover__row {
    border-top: 1px solid var(--app-color-border);
  }
  .detail-discount-popover__section {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid var(--app-color-border);
  }
  .detail-discount-popover__section-title {
    margin-bottom: 2px;
    color: var(--app-color-text-secondary);
    font-size: 10px;
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
  .detail-discount-popover__row strong {
    color: var(--app-color-text);
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
  }
  .detail-discount-popover__iva {
    display: inline-block;
    margin-left: 3px;
    padding: 1px 4px;
    border-radius: 8px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    font-size: 9px;
    font-weight: var(--app-font-semibold);
    vertical-align: 1px;
  }
  .crud-order-table-detail {
    overflow: auto;
    max-height: 350px;    
    min-height: 100px;    
  }
  .block-product-add {
    background: white;
    filter: brightness(0.4);
    border-radius: 15px;
    padding-top: 10px;
    pointer-events: none;
    opacity: 0.5;
  }
  .block-product-add-div {
    position: absolute;
    text-align: center;
    margin-top: 20px;    
  }
  .crud-new-orders-button-add {
    margin-top: 29px;
  }  
  @media (max-width: 767.98px) {
    #container_detail_product_select > div > .form-group {
      margin-bottom: 0;
    }
    .detail-product-pricing-fields {
      margin-top: 12px;
    }
    .detail-product-pricing-fields > .row > [class*="col-"] + [class*="col-"] {
      margin-top: 12px;
    }
    .crud-detail-product-fieldset > .row:first-child > [class*="col-"] .row > [class*="col-"] + [class*="col-"] {
      margin-top: 12px;
    }
    .crud-new-orders-button-add {
      width: 100%;
      margin-top: 8px;
    }
    .crud-new-orders-button-add .btn {
      width: 100%;
    }
  }
  .curd-detail-product-select-unit-measurement {
    font-size: 10px !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
  .curd-detail-product-select-unit-measurement button {
    font-size: 10px;
    padding-left: 3px;
    padding-right: 3px;
  }
  .crud-detail-product-prepend-amount .input-group-prepend .input-group-text {
    padding-left: 3px !important;
    padding-right: 3px !important;    
  }
  .crud-detail-product-append-discount .input-group-append .input-group-text {
    padding-left: 3px !important;
    padding-right: 3px !important;    
  }  
  #container_detail_product_select .popover-body {
    padding: 8px 10px;
  }
  #container_detail_product_select {
    position: relative;
  }
  .detail-product-stock-control {
    position: absolute;
    top: 2px;
    right: 18px;
    z-index: 3;
    pointer-events: auto;
  }
  .detail-product-stock-control .badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 2px 5px;
    font-size: 9px;
    font-weight: var(--app-font-semibold);
    line-height: 1;
  }
  .detail-product-table-stock-control {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    font-size: 14px;
    line-height: 1;
    vertical-align: middle;
    opacity: .58;
  }
  .detail-product-table-stock-control--active {
    color: var(--success);
  }
  .detail-product-table-stock-control--inactive {
    color: var(--secondary);
  }
  .detail-product-popover-list__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 4px 0;
  }
  .detail-product-popover-list__row + .detail-product-popover-list__row {
    border-top: 1px solid var(--app-color-border);
  }
  .detail-product-popover-list__label {
    color: var(--app-color-text-secondary);
    font-size: 11px;
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .detail-product-popover-list__value {
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-detail-product-fieldset fieldset {
    margin-bottom: 0px !important;
  }
</style>
